// src/modules/app-views/crm/components/CardHeaderBottom.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Steps, Tag, Tooltip } from 'antd';
import crmService from '../service';
import useZustand from 'hooks/useZustand';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CrmCardHeaderBottom = ({ boardUid, columnUid, status, isFullscreen }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  // Subscribe to parameters so component re-renders when boards/columns load
  useZustand('app', 'parameters');

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. LOCAL VARIABLES
  // ─────────────────────────────────────────────────────────────────────────────
  const columns = crmService.getColumnsByBoardUid(boardUid);
  if (!columns?.length) return null;

  // Sort columns by order
  const sortedColumns = [...columns].sort((a, b) => a.order - b.order);

  // Find the index of the current column
  const currentIndex = sortedColumns.findIndex(c => c.uid === columnUid);

  // Build Steps items from columns
  const items = sortedColumns.map(col => {
    const item = { title: translateX(col.title) };

    // Show deal outcome tag as description on the final column
    if (col.final) {
      if (status === 'contract_closed') {
        item.content = (
          <Tag color="blue" variant="outlined" style={{ fontSize: 10, margin: 0 }}>
            {translateX('closed_deal')}
          </Tag>
        );
      } else if (status === 'lost') {
        item.content = (
          <Tag color="red" variant="outlined" style={{ fontSize: 10, margin: 0 }}>
            {translateX('lost_deal')}
          </Tag>
        );
      }
    }

    return item;
  });

  // Custom dot with tooltip showing column title
  const customDot = (dot, { index }) => (
    <Tooltip title={translateX(sortedColumns[index]?.title)}>{dot}</Tooltip>
  );

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Steps
      size="small"
      current={currentIndex >= 0 ? currentIndex : 0}
      type="dot"
      items={items}
      style={{ width: '100%', marginTop: isFullscreen ? 24 : 4 }}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CrmCardHeaderBottom;
